/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {userGet, UserGetParams} from "../fn/user/user-get";
import {UserDetailsModel} from "../models/user-details-model";
import {userUpdate, UserUpdateParams} from "../fn/user/user-update";
import { userDelete, UserDeleteParams } from '../fn/user/user-delete';
import {switchAccountPut, SwitchAccountPutParams} from "../fn/user/switch-account-put";
import {
    userEmailChangeConfirmPost,
    UserEmailChangeConfirmPostParams,
} from '../fn/user/user-email-change-confirm-post';
import {
    userEmailChangeRequestPost,
    UserEmailChangeRequestPostParams,
} from '../fn/user/user-email-change-request-post';
import { usersGet } from '../fn/user/users-get';
import { UserModel } from '../models/user-model';
import {
    userInitiatedQuestionnairesGet,
    UserInitiatedQuestionnairesGetParams,
} from '../fn/user/user-initiated-questionnaires-get';
import {
    userAssociatedQuestionnairesGet,
    UserAssociatedQuestionnairesGetParams,
} from '../fn/user/user-associated-questionnaires-get';
import {
    userScheduledQuestionnairesGet,
    UserScheduledQuestionnairesGetParams,
} from '../fn/user/user-scheduled-questionnaires-get';
import { PaginatedList } from '../models/paginator/paginated-list';
import { SurveyRespondentQuestionnaireModel } from '../models/survey-respondent-questionnaire-model';
import { SurveyRespondentScheduledQuestionnaireModel } from '../models/survey-respondent-scheduled-questionnaire-model';
import { TokenModel } from '../models/token-model';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Gets a singular user
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `userGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    userGet$Response(params: UserGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<UserDetailsModel>> {
        return userGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets a singular user
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `userGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    userGet(params: UserGetParams, headers: HttpHeaders, context?: HttpContext): Observable<UserDetailsModel> {
        return this.userGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<UserDetailsModel>): UserDetailsModel => r.body)
        );
    }

    /**
     * Gets all users in the system (SuperAdmin / Owner only)
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `usersGet()` instead.
     */
    usersGet$Response(headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<UserModel[]>> {
        return usersGet(this.http, this.rootUrl, headers, context);
    }

    /**
     * Gets all users in the system (SuperAdmin / Owner only)
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `usersGet$Response()` instead.
     */
    usersGet(headers: HttpHeaders, context?: HttpContext): Observable<UserModel[]> {
        return this.usersGet$Response(headers, context).pipe(
            map((r: StrictHttpResponse<UserModel[]>): UserModel[] => r.body)
        );
    }

    /**
     * Soft-deactivates a user while retaining historical questionnaire data.
     */
    userDelete$Response(params: UserDeleteParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return userDelete(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Soft-deactivates a user while retaining historical questionnaire data.
     */
    userDelete(params: UserDeleteParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
        return this.userDelete$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }

    /**
     * Gets questionnaire instances initiated by a user
     */
    userInitiatedQuestionnairesGet$Response(params: UserInitiatedQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>> {
        return userInitiatedQuestionnairesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets questionnaire instances initiated by a user
     */
    userInitiatedQuestionnairesGet(params: UserInitiatedQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<PaginatedList<SurveyRespondentQuestionnaireModel>> {
        return this.userInitiatedQuestionnairesGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>): PaginatedList<SurveyRespondentQuestionnaireModel> => r.body)
        );
    }

    /**
     * Gets questionnaire instances associated with a user
     */
    userAssociatedQuestionnairesGet$Response(params: UserAssociatedQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>> {
        return userAssociatedQuestionnairesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets questionnaire instances associated with a user
     */
    userAssociatedQuestionnairesGet(params: UserAssociatedQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<PaginatedList<SurveyRespondentQuestionnaireModel>> {
        return this.userAssociatedQuestionnairesGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentQuestionnaireModel>>): PaginatedList<SurveyRespondentQuestionnaireModel> => r.body)
        );
    }

    /**
     * Gets questionnaire instances scheduled by a user
     */
    userScheduledQuestionnairesGet$Response(params: UserScheduledQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>>> {
        return userScheduledQuestionnairesGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets questionnaire instances scheduled by a user
     */
    userScheduledQuestionnairesGet(params: UserScheduledQuestionnairesGetParams, headers: HttpHeaders, context?: HttpContext): Observable<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>> {
        return this.userScheduledQuestionnairesGet$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<SurveyRespondentScheduledQuestionnaireModel>>): PaginatedList<SurveyRespondentScheduledQuestionnaireModel> => r.body)
        );
    }

    /**
     * Sends a verification code to a new email address for the current user.
     */
    userEmailChangeRequestPost$Response(params: UserEmailChangeRequestPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return userEmailChangeRequestPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Sends a verification code to a new email address for the current user.
     */
    userEmailChangeRequestPost(params: UserEmailChangeRequestPostParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
        return this.userEmailChangeRequestPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }

    /**
     * Confirms a new email address and returns refreshed auth tokens.
     */
    userEmailChangeConfirmPost$Response(params: UserEmailChangeConfirmPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<TokenModel>> {
        return userEmailChangeConfirmPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Confirms a new email address and returns refreshed auth tokens.
     */
    userEmailChangeConfirmPost(params: UserEmailChangeConfirmPostParams, headers: HttpHeaders, context?: HttpContext): Observable<TokenModel> {
        return this.userEmailChangeConfirmPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<TokenModel>): TokenModel => r.body)
        );
    }


    /**
     * Updates a singular user
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `userUpdate()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    userUpdate$Response(params: UserUpdateParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return userUpdate(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Updates a singular user
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `userUpdate$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    userUpdate(params: UserUpdateParams, headers: HttpHeaders, context?: HttpContext): Observable<void> {
        return this.userUpdate$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<void>): void => r.body)
        );
    }

    /**
     * Swaps a users selected account
     *
     *
     *
     * This method provides access only to the response body.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    userSwapAccount$Response(params: SwitchAccountPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return switchAccountPut(this.http, this.rootUrl, params, headers, context);
    }
}
